export default __webpack_public_path__ + "static/media/hht2_direction_timeline_02.b590b242.jpg";